"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrosingularityPlant = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var CardRequirements_1 = require("../CardRequirements");
var MicrosingularityPlant = (function (_super) {
    __extends(MicrosingularityPlant, _super);
    function MicrosingularityPlant() {
        return _super.call(this, {
            name: CardName_1.CardName.MICROSINGULARITY_PLANT,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.ENERGY],
            cost: 10,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.colonyTiles(2).any(); }),
            metadata: {
                description: 'Requires 2 colonies on the Moon. Increase your energy production 2 steps.',
                cardNumber: 'M40',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(2); });
                }),
            },
        }) || this;
    }
    ;
    MicrosingularityPlant.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 2, { log: true });
        return undefined;
    };
    return MicrosingularityPlant;
}(Card_1.Card));
exports.MicrosingularityPlant = MicrosingularityPlant;
//# sourceMappingURL=MicrosingularityPlant.js.map